module.exports = __webpack_public_path__ + "img/my_books.2c9b4ee4.jpeg";